export default function SvgPause2() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9 7a1 1 0 00-2 0v10a1 1 0 102 0V7zm8 0a1 1 0 10-2 0v10a1 1 0 102 0V7z"
        clipRule="evenodd"
      ></path>
    </svg>
    </>
  );
}
